import React from 'react';
import moment from 'moment';
import { delimited } from '@/common/utils/commonUtil';
import type { Project } from '../../models/projects/project';
import { STATUS } from '../../models/projects/project';

interface Props {
  project: Project;
}

export default function CardSpecificInvestor(props: Props) {
  const { project } = props;

  if (
    project.status === STATUS.inProgress &&
    moment().isAfter(moment(project.startAt)) &&
    project.productsSize > 0 &&
    project.specificSolicitLimit
  ) {
    return (
      <div className="specific-investor container">
        <div className="row d-flex align-items-center bg-lightcyan mb-20 pt-10 pb-10">
          <div className="col-6 font-weight-bold">特定投資家枠</div>
          <div className="col-6 text-right solicit-limit">
            <span>{delimited(project.specificSolicitLimit)}円</span>
          </div>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
}
